import script from "./ViewUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewUsers.vue?vue&type=script&setup=true&lang=ts"

import "./ViewUsers.vue?vue&type=style&index=0&id=095366a0&lang=scss"

const __exports__ = script;

export default __exports__